module.exports = __webpack_public_path__ + "img/yancao_yanan_suoluetu.84157f83.png";